import { render } from '@wordpress/element';
import App from './App';

if (document.getElementById('js-generational-media-habits')) {
    render(<App />, document.getElementById('js-generational-media-habits'));
}
